import { EvtHeader } from "components/header";
import React from "react";
import { useParams } from "react-router-dom";
import HolidayForm from "../form";

const UpdateHoliday = () => {
  const { holidayId } = useParams();

  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Update Holiday" />
      <div className="p-6 max-w-2xl">
        <HolidayForm holidayId={holidayId} />
      </div>
    </div>
  );
};

export default UpdateHoliday;
